/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetManpowerSettingQuery } from '../../models/get-manpower-setting-query';
import { GetManpowerSettingQueryResult } from '../../models/get-manpower-setting-query-result';

export interface ApiManpowerSettingGetManpowerSettingsPost$Params {
  
    /**
     * The query parameters for fetching manpower settings.
     */
    body?: GetManpowerSettingQuery
}

export function apiManpowerSettingGetManpowerSettingsPost(http: HttpClient, rootUrl: string, params?: ApiManpowerSettingGetManpowerSettingsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManpowerSettingQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiManpowerSettingGetManpowerSettingsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetManpowerSettingQueryResult>;
    })
  );
}

apiManpowerSettingGetManpowerSettingsPost.PATH = '/api/ManpowerSetting/GetManpowerSettings';
